/**
 * Centralised route path helpers.
 *
 * These helpers generate navigation paths that correspond to the React Router
 * route definitions in App.tsx. Using them instead of inline template strings
 * avoids typos and makes route changes a single-point edit.
 */
export const routes = {
  inspire: () => "/inspire",
  productions: () => "/productions",
  production: (projectId: string) => `/productions/${projectId}`,
  copilot: () => "/copilot",
  dashboard: () => "/inspire", // Default landing page
  acceptTerms: () => "/accept-terms",
  authDebug: () => "/auth/debug",
  organisationMembers: (organisationId: string) =>
    `/organisations/${organisationId}/members`,
  organisationTeams: (organisationId: string) =>
    `/organisations/${organisationId}/teams`,
  organisationSettings: (organisationId: string) =>
    `/organisations/${organisationId}/settings`,
  organisationUsage: (organisationId: string) =>
    `/organisations/${organisationId}/usage`,
  settings: (section?: string) => `/settings/${section ?? "email"}`,
  support: () => "/support",
  supportTicket: (ticketId: string) => `/support/tickets/${ticketId}`,
  organisationPolicies: (organisationId: string) =>
    `/organisations/${organisationId}/policies`,
  organisationServices: (organisationId: string) =>
    `/organisations/${organisationId}/services`,
  organisationBilling: (organisationId: string) =>
    `/organisations/${organisationId}/billing`,
  workflow: (workflowId: string) => `/workflows/${workflowId}`,
  timeline: (projectId: string) => `/video-editor/${projectId}`,
  library: (projectId: string) => `/productions/${projectId}/library`,
} as const;
